<template>
  <footer v-editable="blok" class="site-footer theme-dark">
    <div class="site-footer-main row">
      <div class="site-footer-main-column col-12 col-sm-12 col-md-5 col-lg-6">
        <component
          :is="item.component | dashify"
          v-for="item in blok.office"
          :key="item._uid"
          :blok="item"
          :modifier-class="getModifierClass(item.component)"
        />
      </div>
      <div class="site-footer-main-column col-12 col-sm-8 col-md-5 col-lg-4">
        <component
          :is="item.component | dashify"
          v-for="item in blok.contact"
          :key="item._uid"
          :blok="item"
          :modifier-class="getModifierClass(item.component)"
        />
      </div>
      <div class="site-footer-main-column col-12 col-sm-2 col-md-2 col-lg-2">
        <ul class="site-footer__social-list list--unstyled">
          <li v-for="item in blok.social" :key="item._uid">
            <component
              :is="item.component | dashify"
              :blok="item"
              modifier-class="site-footer__link"
            />
          </li>
        </ul>
      </div>
    </div>
    <div class="site-footer-bottom row">
      <ul class="site-footer-bottom__legal-list list--unstyled col-12">
        <li
          class="site-footer-bottom__legal-list-item site-footer-bottom__legal-list-item--logo"
        >
          <component
            :is="'a_imageSource' | dashify"
            v-if="blok.logo && blok.logo[0].image"
            :blok="blok.logo[0]"
            :image-url="blok.logo[0].image"
            alt=""
          />
        </li>
        <li
          v-for="item in blok.legal"
          :key="item._uid"
          class="site-footer-bottom__legal-list-item"
        >
          <component
            :is="item.component | dashify"
            :blok="item"
            modifier-class="site-footer-bottom__legal"
          />
        </li>
      </ul>
      .
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getModifierClass: (componentName) => {
      switch (componentName) {
        case 'a_link':
          return 'site-footer__link site-footer__link--map'
        default:
          return 'site-footer__text'
      }
    },
  },
}
</script>

<style lang="scss">
@import '../../assets/scss/settings';

.site-footer {
  padding: spacer(4) spacer(2);

  .generic-text {
    margin: 0 0 16px 0;
  }
}

.site-footer-main {
  text-align: left;
  word-break: break-word;
  max-width: $footer-maxwidth;
  margin: 0 auto;
}

.site-footer-main-column {
  margin-bottom: spacer(3);
  padding: 0;

  p {
    @include font-size(14, rem-v(24));

    margin: 0;
  }
}

.site-footer__link {
  @include font-size(14, rem-v(20));

  padding-bottom: spacer(0.5);
  border-bottom: 1px solid $white;

  &--map {
    display: inline-block;
    margin-top: spacer(1);
  }
}

.site-footer__text {
  margin-bottom: spacer(1);
}

.site-footer__social-list {
  li {
    margin-bottom: spacer(1.5);
  }
}

.site-footer-bottom {
  text-align: left;
  max-width: $footer-maxwidth;
  margin: 0 auto;
}

.site-footer-bottom__legal-list {
  border-top: 1px solid $gray-800;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0;
}

.site-footer-bottom__legal-list-item {
  flex: 0 0 100%;
  margin-top: spacer(1);

  &--logo {
    flex: 20px 0 initial;
    margin: spacer(2.2) auto spacer(1.5) 0;
    display: block;
    width: 20px;
    height: 20px;

    img {
      width: 20px;
      height: auto;
    }
  }

  /* The tribal Worldwide line */
  &:nth-child(2) {
    p {
      @include font-size(14, rem-v(16));
    }
  }
}

.site-footer-bottom__legal {
  @include font-size(12, rem-v(16));

  display: block;

  p {
    @include font-size(14, rem-v(18));

    margin: 0;
  }
}

@include media-breakpoint-up(sm) {
  .site-footer {
    padding: spacer(4) spacer(3) spacer(3);
  }

  .site-footer-main {
    margin-top: 0;

    &-column {
      margin-bottom: spacer(4);

      &:nth-child(3) {
        a {
          @include font-size(14, rem-v(24));
        }
      }
    }

    p {
      @include font-size(14, rem-v(24));
    }
  }

  .site-footer-bottom {
    margin-top: spacer(3);
    text-align: right;
  }

  .site-footer-bottom__legal-list {
    justify-content: flex-start;
  }

  .site-footer-bottom__legal-list-item {
    flex: 0 0 auto;
    margin-left: spacer(2);
    margin-top: spacer(3);

    &--logo {
      margin: spacer(2.5) auto 0 0;
    }
  }
}

@include media-breakpoint-up(md) {
  .site-footer {
    padding: spacer(6) spacer(4) spacer(3);
  }

  .site-footer-bottom__legal-list-item {
    &--logo {
      flex: 32px 0 initial;
      width: 32px;
      height: 32px;

      img {
        width: 32px;
      }
    }
  }
}

@include media-breakpoint-up(lg) {
  .site-footer {
    padding: spacer(9) spacer(4) spacer(3);
  }

  .site-footer-bottom {
    margin-top: spacer(7);
  }

  .site-footer-main-column {
    margin-bottom: 0;
  }

  .site-footer-bottom__legal-list-item {
    margin-left: spacer(3);

    &:nth-child(2) {
      order: 0;
      margin-top: spacer(3);

      p {
        @include font-size(12, rem-v(16));
      }
    }

    &:first-child {
      margin-left: 0;
      flex: 0 0 auto;
    }
  }
}

// Style to fix the issue related to the site-footer-bottom on screen sizes between 575 to 1062 pixels
@media screen and (min-width: 575px) and (max-width: 1062px) {
  .site-footer-bottom__legal-list {
    display: block;
    text-align: right;

    &-item {
      display: inline-block;
    }
    &-item:nth-child(1) {
      width: 10%;
    }
    &-item:nth-child(2) {
      width: 90%;
      margin: 0;
    }

    &-item:nth-child(3) {
      margin-left: 0;
    }
  }
}
</style>
